import React, {Component} from 'react';
import {observer} from "mobx-react";
import objectPath from "object-path";

class MultiStr extends Component {
  getValue(item) {
    if(this.props.field && this.props.field.view_options && this.props.field.view_options.view_code) {
      return objectPath.get(item, this.props.field.view_options.view_code);
    }
    return "—";
  }
  render() {
    if(this.props.value && Array.isArray(this.props.value)) {
      const multiReturn=this.props.value.map((item, index)=>{
        return (
          <div className="pbottom5 fs13" key={index}>
            <span className="dib bg-w3 rad4 hpadd5 vpadd2">{this.getValue(item)}</span>
          </div>
        )
      });

      return multiReturn;
    }

    return null;
  }
}

export default observer(MultiStr);